import { reduceAction } from '@elab/core/store/helpers';

import types from './types';

export const initialState = () => ({
    data: [],
    deliveryBlocked: false,
    checkRts: false,
    rtsAvailable: true,
    rtsUnreachableMsg: '',
    showRtsUnreachableMsg: false,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.SET_DELIVERY_MODES: {
            return reduceAction(state, 'data', action.payload);
        }
        case types.SET_DELIVERY_BLOCKED: {
            return reduceAction(state, 'deliveryBlocked', action.payload);
        }
        case types.SET_CHECK_RTS: {
            return reduceAction(state, 'checkRts', true);
        }
        case types.SET_RTS_AVAILABLE: {
            return reduceAction(state, 'rtsAvailable', action.payload);
        }
        case types.SET_RTS_UNREACHABLE_MSG: {
            return reduceAction(state, 'rtsUnreachableMsg', action.payload);
        }
        case types.SET_SHOW_RTS_UNREACHABLE_MSG: {
            return reduceAction(state, 'showRtsUnreachableMsg', action.payload);
        }
        default:
            return state;
    }
};

export default reducers;
